import type { ReactNode } from 'react';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v8';

export function UrlStateProvider({ children }: { children: ReactNode }) {
  return <NuqsAdapter>{children}</NuqsAdapter>;
}
